import { MenuOutlined } from '@ant-design/icons';
import { useUser } from '@dofleini/security';
import classNames from 'classnames';
import pick from 'lodash/pick';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

import { useResponsive } from '@/contexts/ResponsiveContext';
import NavMenu from '@/layout/Menu';
import { findActiveKeys } from '@/layout/Menu/NavigationMenu';
import { layout, publicContent } from '@/settings';

import style from './index.less';

const PublicNavMenu = ({ mode, inverse }) => {
  const { t } = useTranslation('navigation');
  const { isAuthenticated } = useUser();
  const { isMobile } = useResponsive();
  const { push } = useHistory();
  const { pathname } = useLocation();
  const headerOptions = useMemo(() => pick(layout.options, ['theme']), []);
  
  // eslint-disable-next-line no-unused-vars
  const processNavigation = useCallback(({ title, link, authenticated, ...rest }) => {
    title = t(title || link);
    return {
      title,
      link,
      ...rest
    };
  }, [t]);
  
  const verifyNavigation = useCallback(({ authenticated, onlyMobile }) => {
    if (onlyMobile && !isMobile) return false;
    if (!authenticated) return true;
    return !!isAuthenticated;
  }, [isAuthenticated, isMobile]);
  //
  const navigation = useMemo(() => publicContent.filter(verifyNavigation).map(processNavigation), [processNavigation, verifyNavigation]);
  
  const handleClick = useCallback(({ link }) => {
    push(link);
  }, [push]);
  
  const openKeys = useMemo(() => findActiveKeys(navigation, pathname), [navigation, pathname]);
  
  const baseMenuProps = useMemo(() => ({
    defaultSelectedKeys: openKeys,
    selectedKeys: openKeys,
    selectable: false
  }), [openKeys]);
  
  const menuProps = useMemo(() => ({
    ...baseMenuProps,
    openKeys,
  }), [baseMenuProps, openKeys]);
  
  return <div>
    <div/>
    <div className={classNames(style.container, 'hidden xml:block', { [style.invertClass]: inverse })}>
      <NavMenu
        menu={navigation}
        {...headerOptions}
        mode={mode}
        overflowedIndicator={<MenuOutlined/>}
        onClick={handleClick}
        menuProps={menuProps}
      />
    </div>
  </div>;
};

export default memo(PublicNavMenu);

PublicNavMenu.propTypes = {
  inverse: PropTypes.bool,
  mode: PropTypes.string
};

PublicNavMenu.defaultProps = {
  inverse: false,
  mode: 'horizontal'
};
